/**
 * @module Material
 * @memberof Dashboard.Layout
 */

import { NgModule } from '@angular/core';
import { MatNativeDateModule, MatRippleModule, MatPseudoCheckboxModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatTreeModule } from '@angular/material/tree';
import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';

@NgModule({
	exports: [
		FlexLayoutModule,
		MatNativeDateModule, // Version without moment.js
		MatRippleModule,
		// @see [mat-pseudo-checkbox in Angular 14](https://stackoverflow.com/questions/76071331/update-angular-14-to-15-mat-pseudo-checkbox-not-visible-anymore)
		MatPseudoCheckboxModule,
		MatCheckboxModule,
		MatRadioModule,
		MatSlideToggleModule,
		MatInputModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatSelectModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatBadgeModule,
		MatListModule,
		MatGridListModule,
		MatTableModule,
		MatTabsModule,
		MatSortModule,
		MatPaginatorModule,
		MatSidenavModule,
		MatToolbarModule,
		MatTooltipModule,
		MatDialogModule,
		MatIconModule,
		CdkTreeModule,
		MatTreeModule,
		MatExpansionModule,
		MatMenuModule,
		MatCardModule,
		MatChipsModule,
		MatProgressBarModule,
		MatSnackBarModule,
		MatAutocompleteModule,
		MatStepperModule
	],
	providers: [
		// @link https://codinglatte.com/posts/angular/angular-material-form-field-appearance/
		{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
		{ provide: MAT_SNACK_BAR_DATA, useValue: {} },
		{ provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true } },
	],
})
export class MaterialModule {}
